// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! * [Scalable Text in CSS with Maximum and Minimum Sizes](https://github.com/kevinmack18/SCALABLE-TEXT-IN-CSS) */.front-main{display:flex;flex-direction:column;margin:auto;max-width:850px;padding:1rem 0 2rem;width:100%}.front-main:after{content:\"\";display:table;clear:both}@media only screen and (min-width:979px){.front-main{flex-wrap:nowrap}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
